export class VehicleModel {
    id: number;
    name: string | null | '';
    inventoryCode: string | null | '';
    classId: number;
    weight: number;
    length: number;
    width: number;
    height: number;
    serviceTime: number | null;
    order: number;
    volumeCubic: number;
    className: string|null;
    isActive: boolean;

    constructor () {
        this.id = 0;
        this.name = null;
        this.inventoryCode = null;
        this.classId = 0;
        this.weight = 0;
        this.length = 0;
        this.width = 0;
        this.height = 0;
        this.serviceTime = null;
        this.order = 0;
        this.volumeCubic = 0;
        this.className = null;
        this.isActive = true;
    }

    public static fromJson (json: any): VehicleModel {
        const vehicle = new VehicleModel;
        Object.assign(vehicle, {
            id: json.id,
            name: json.vehicle_type_name || json.name,
            inventoryCode: json.inventory_code,
            classId: json.class_id,
            weight: json.weight,
            length: json.length,
            width: json.width,
            height: json.height,
            serviceTime: json.service_time,
            order: json.order || 0,
            volumeCubic: 0,
            className: json?.class?.name || '-',
            isActive: json.is_active ?? true
        });
        return vehicle;
    }
}